import { FundingProduct } from '@frontend/components/agromarket/core/access-control'

export enum ELoanProductCollapsing {
  ORDER = 'ORDER',
  CALC = 'CALC',
  CONSULT = 'CONSULT',
}

export const LOAN_PRODUCTS_HAS_ONLY_CONSULT_FORM: FundingProduct[] = [FundingProduct.SBERPAY]
